import { useEffect } from "react";
import { useAppDispatch } from "../../../../../../store/config";
import { resetExercises } from "../../../../../../store/features/exercises/exercises-slice";
import { ExercisesLayout } from "./style";
import { Outlet } from "react-router-dom";

export const Exercises = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetExercises());
    };
  }, []);

  return (
    <ExercisesLayout>
      <Outlet />
    </ExercisesLayout>
  );
};
